import { Transforms } from "slate";
export var insertTable = function (editor, row, column) {
    if (row === void 0) { row = 2; }
    if (column === void 0) { column = 3; }
    var table = { type: "table", children: [] };
    for (var r = 0; r < row; r++) {
        var tableRow = {
            type: "table-row",
            children: [],
        };
        for (var c = 0; c < column; c++) {
            var tableCell = { type: "table-cell", children: [] };
            var text = { text: "" };
            if (c !== 0 && r === 0) {
                text.text = "Column-".concat(c);
            }
            else if (c === 0 && r !== 0) {
                text.text = "Row-".concat(r);
            }
            tableCell.children.push(text);
            tableRow.children.push(tableCell);
        }
        table.children.push(tableRow);
    }
    Transforms.insertNodes(editor, table);
};
